import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class EnergySourceResolverService  {
  resolve(route: ActivatedRouteSnapshot) {
    if (route.parent.parent.url.find((x) => x.path.indexOf('gas') > -1)) {
      return 'GAS';
    }

    return 'POWER';
  }
}
